import { hasEqualOrHigherAccessThanSpecifiedRole } from "~auth/helpers";
import { useGetCurrentAccountCache } from "~auth/queries/useGetCurrentAccount";
import { ACCOUNT_USER_ROLE } from "~maps-portal/types/__generated/gql/graphql";

export const useIsCreateMapAllowed = () => {
	const { data: account } = useGetCurrentAccountCache();

	return hasEqualOrHigherAccessThanSpecifiedRole(
		account,
		ACCOUNT_USER_ROLE.ADMIN,
	);
};
